import { render } from "@/components/pages/individualWorkSupport/requirement048/Requirement048.html?vue&type=template&id=c2e877fa&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement048/Requirement048.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement048/Requirement048.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement048/Requirement048.scss?vue&type=style&index=0&id=c2e877fa&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e877fa"]])

export default __exports__